"use client";
//#region packages/@mantine/core/src/components/Combobox/get-options-lockup/get-option-by-label.ts
/**
* Finds an enabled option by its label, ignoring casing and surrounding whitespace. Returns
* `undefined` when the label is ambiguous: options with duplicate labels are valid data, and there
* is no way to tell which of them was meant.
*/
function getOptionByLabel(optionsLockup, label) {
	const normalizedLabel = label.trim().toLowerCase();
	if (normalizedLabel === "") return;
	const matchedOptions = Object.values(optionsLockup).filter((option) => !option.disabled && option.label.trim().toLowerCase() === normalizedLabel);
	return matchedOptions.length === 1 ? matchedOptions[0] : void 0;
}
//#endregion
export { getOptionByLabel };

//# sourceMappingURL=get-option-by-label.mjs.map